module.exports = __webpack_public_path__ + "static/media/new-arteon.524feabd.png";